import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=657457b5&scoped=true&"
import script from "./SupportModal.vue?vue&type=script&lang=js&"
export * from "./SupportModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=657457b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657457b5",
  null
  
)

export default component.exports